import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/latest-news/PostsWrapper.tsx");
